import { useEffect, useState } from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import {
  InteractionRequiredAuthError,
  InteractionStatus,
} from "@azure/msal-browser";
import { Navigate } from "react-router-dom";
import { loginRequest, msalInstance } from "../utils/auth/AuthProvider";

const AuthPage = () => {
  const { accounts, inProgress } = useMsal();
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    setShowButton(false);
    let action = () => console.log();
    let timer = setTimeout(() => {
      action();
    }, 2000);
    if (inProgress === InteractionStatus.None) {
      if (accounts.length > 0) action = () => <Navigate to={"/"} />;
      else action = () => setShowButton(true);
    }

    return () => clearTimeout(timer);
  }, [accounts]);

  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    setShowButton(false);
    if (!isAuthenticated) {
      msalInstance
        .ssoSilent(loginRequest)
        .then((res) => {
          msalInstance.setActiveAccount(res.account);
        })
        .catch((error) => {
          // if (error instanceof InteractionRequiredAuthError) {
          msalInstance.loginRedirect();
          // }
        });
    }
  }, []);

  return <div className="middle-page"></div>;
};

export default AuthPage;
